<div class="main-toolbar d-print-none">
  <div class="main-toolbar-content d-flex justify-content-between align-items-center w-100">
    <span class="mail-box">
      <span class="admin-workbrench">
        <a [routerLink]="['/home']">
          <img class="img-responsive" src="../../assets/images/gem.svg" alt="">
        </a>
      </span>
    </span>

    <div class="menu-item-wrapper d-flex align-items-center" (outsideClick)="toggleSubMenu(null)">
      <ul class="main-menu d-flex align-items-center m-0 p-0 list-unstyled">
        <li *ngFor="let menuItem of menuItems; let i = index" class="menu-item-template mr-5" (click)="toggleSubMenu(i)">
          <div class="d-flex align-items-center k-level-{{ menuItem.level }}">
            <ng-container>
              <span *ngIf="!!menuItem.isCustom; else defaultIcon" class="custom-menu-icon">
                <mat-icon class="custom-menu-icon" [svgIcon]="menuItem.icon"></mat-icon>
              </span>
              <ng-template #defaultIcon>
                <span class="k-icon k-font-icon {{ menuItem.icon }}"></span>
              </ng-template>
            </ng-container>
            <span class="menu-item" [ngClass]="{ expanded: openMenuIndex === i}">{{ menuItem.text }}</span>
            <span 
              *ngIf="menuItem.children" 
              class="k-icon k-font-icon k-i-arrow-chevron-down"
              [ngClass]="{'k-i-arrow-chevron-down': openMenuIndex === i, 'k-i-arrow-chevron-right': openMenuIndex !== i}"
            ></span>
          </div>
          <div
            *ngIf="openMenuIndex === i"
           class="floating-sub-menu" 
           [ngClass]="{ expanded: openMenuIndex === i }" 
           #subMenu
          >
            <ng-container *ngFor="let column of menuItem.columns">
              <div class="floating-sub-menu-column">
                <div class="floating-sub-menu-category" *ngFor="let subMenuItem of column">
                  <span class="floating-sub-menu-category-title">{{ subMenuItem.category.toUpperCase() }}</span>
                  <div class="floating-sub-menu-items">
                    <a *ngFor="let subMenuItemChild of subMenuItem?.items" class="floating-sub-menu-item mr-4" [routerLink]="subMenuItemChild.path">
                      <span *ngIf="!subMenuItemChild.header">{{subMenuItemChild.text}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </li>
      </ul>
    </div>

    <span class="help ml-auto ml-15 mr-4">
      <span class="help-workbrench">
        <a [routerLink]="['/help-center']">
          <span class="k-icon k-font-icon k-i-help k-icon-20"> </span>
        </a>
      </span>
    </span>

    <kendo-menu class="user-menu" [items]="userMenuItems" (select)="selectUserMenuItem($event)">
      <ng-template kendoMenuItemTemplate let-item="item">
        <span *ngIf="item.text === 'userHeader'" class="k-icon k-font-icon k-i-user gray-color"></span>
        <span class="gray-color k-icon k-font-icon" [ngClass]="iconClass(item)"></span>
        <span [ngClass]="textClass(item.class)">{{item.text !== 'userHeader' ? item.text : ''}} </span>
      </ng-template>
    </kendo-menu>
  </div>
</div>

<div class="layout-container">
  <router-outlet></router-outlet>
  <prism-scheduled-job-modal
    *ngIf="scheduledJob$ | async as scheduledJob"
    (closed)="closeScheduleJobModal($event)"
    [job]="scheduledJob"
    [jobType]="scheduledJob.options?.jobType"
    [modalTitle]="scheduledJob.options?.modalTitle"
    [modalMessage]="scheduledJob.options?.modalMessage"
    [modalSubTitle]="scheduledJob.options?.modalSubTitle"
  ></prism-scheduled-job-modal>
</div>
<div class="layout-footer container-fluid">
  <div class="row">
    <div class="col-6 offset-3">
      <div class="d-flex justify-content-around footer-texts">
        <span class="copyright">©2013-{{currentYear | date: 'yyyy': null: dateLocalePipe}} INTEGRA PARTNERS LLC</span>
        <a target="_blank" href="{{privacyPolicyURL}}" rel="noopener">Privacy Policy</a>
        <a target="_blank" href="{{termsURL}}" rel="noopener">Terms & Conditions</a>
      </div>
    </div>
  </div>
</div>

<prism-modal-loader></prism-modal-loader>

<prism-modal title="PRISM Maintenance Notice" titleIconType="danger" titleIcon="warning"
  [actions]="maintenancePopupActions" [opened]="showMaintenanceDialog" (cancel)="showMaintenanceDialog = false">
  <div>The Prism Platform will be down for scheduled maintance within {{timeUntilRedirect}}. Please save all changes.
  </div>
</prism-modal>
